// extracted by mini-css-extract-plugin
export default {"select":"select--nOjSm","value":"value--VgM04"};